import { observable } from 'mobx';

import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { FlightsPlacardType } from 'types/shared';
import { FlightsImagePlacardInformationLoaded } from '__generated__/api';
import FlightsImagePlacard = FlightsImagePlacardInformationLoaded.Fragment;

export class MessagingCardsStore extends Store {
  @observable public messagingCards?: FlightsPlacardType[];
  @observable public separateTicketBanner?: FlightsImagePlacard;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
MessagingCardsStore.DEFAULTS = {
  messagingCards: []
};
